import { AUTH_EXPIRED_EVENT } from './axiosInstance';

const notifyAuthExpired = () => {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
};

const createHeaders = (includeJson = true, extraHeaders = {}) => {
  const headers = { ...extraHeaders };
  const token = localStorage.getItem('token');

  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const apiRequest = async (url, options = {}) => {
  const { isFormData = false, headers = {}, ...restOptions } = options;
  const response = await fetch(url, {
    ...restOptions,
    headers: createHeaders(!isFormData, headers),
  });

  // Keep authorized users signed in when an endpoint rejects a permission.
  if (response.status === 401) {
    notifyAuthExpired();
  }

  return response;
};

export const apiJson = async (url, options = {}) => {
  let nextOptions = options;
  const selectedBranchId = localStorage.getItem('selected_branch_id');
  if (selectedBranchId && !options.isFormData) {
    try {
      const body = options.body ? JSON.parse(options.body) : {};
      nextOptions = { ...options, body: JSON.stringify({ ...body, branch_id: body.branch_id || selectedBranchId }) };
    } catch (error) {
    }
  }
  const response = await apiRequest(url, nextOptions);
  const data = await response.json();

  return { response, data };
};
